import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { ReferentialService } from "src/app/api/services";
import * as LanguageActions from "./language.actions";

@Injectable()
export class LanguageEffects {
	constructor(private actions$: Actions, private referentialService: ReferentialService) { }

	public loadLanguageList$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(LanguageActions.loadLanguages),
			switchMap(() =>
				this.referentialService.referentialGetLanguages$Json().pipe(
					map((languages) => {
						const data = [
							languages?.filter(lang => lang.languageCode == "FR")[0] ?? null,
							languages?.filter(lang => lang.languageCode == "NL")[0] ?? null,
							languages?.filter(lang => lang.languageCode == "EN")[0] ?? null,
							languages?.filter(lang => lang.languageCode == "DE")[0] ?? null,
						].filter(lang => lang !== null);
						return LanguageActions.loadLanguageListSuccess({ data })
					}),
					catchError((err) => of(LanguageActions.loadLanguageListFailure({ error: err })))
				)
			)
		);
	});
}